// src/services/userService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  USER_DETAILS,
  USER_EDIT,
  USER_EXPORT,
  USER_LIST,
  STAFF_ADD,
  CONTACT_US,
  CONTACT_UPDATE
} from "../../config/constants"; // Adjust endpoints as per your config

const contactUsService = createApi({
  reducerPath: "contactUsService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Contact"],
  endpoints: (builder) => ({
    getContactUs: builder.query({
      query: (bodyData) => ({
        url: CONTACT_US, // Endpoint to fetch user list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Contact"],
    }),

    updateUser: builder.mutation({
      query: ({ userId, updatedData }) => ({
        url: `${CONTACT_UPDATE}/${userId}`, // Endpoint to update a user
        method: "PUT",
        data: updatedData, // Updated user data
      }),
      invalidatesTags: ["Contact"],
    }),
    
   
    
    
   

    
  }),
});

// Export hooks for usage in functional components
export const {
  useGetContactUsQuery,
  //useGetUserDetailsQuery,
  // useAddUserMutation,
  useUpdateUserMutation,
  //useAddStaffMutation,
  // useDeleteUserMutation,
  //useGetUsersExportFileMutation,
} = contactUsService;

// Export the reducer to be included in the store
export default contactUsService;
